import { useState } from 'react';
import styles from 'features/chatAssist/components/chatAssist.module.scss';
import { ClickAwayListener } from '@material-ui/core';

const ActionButtonTooltip = ({ title = "", placeholder = "", onClose = () => {}, onSubmit = () => {} }) => {
  const [reason, setReason] = useState("");
  
  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      e.stopPropagation();
      setReason(reason + " ");
    }
    if (e.key === 'Enter') {
      onSubmit(reason);
      onCloseTooltip();
    }
  };

  const onCloseTooltip = () => {
    onClose(reason);
    setReason("");
  };

  return (
    <ClickAwayListener onClickAway={onCloseTooltip}>
      <div className={styles.tooltip}>
        <p>{title}</p>
        <input
          className={styles.feedbackInput}
          placeholder={placeholder}
          value={reason}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => setReason(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
    </ClickAwayListener>
  );
};

export default ActionButtonTooltip;
